import { useMutation, useQueryClient } from 'react-query';
import { API } from 'api';
import { toastPush } from 'modules';
import { useDispatch } from 'react-redux';
import { IUpdateGlobalCutOffPayload } from './shared';

const updateGlobalCutOffData = (payload: IUpdateGlobalCutOffPayload) => {
  return API.newPut(`api/admin/setting/globalWithdrawalCycle/${payload.id}`, payload);
};

export const useUpdateGlobalCutOffData = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation(updateGlobalCutOffData, {
    onSuccess: (_data, variables) => {
      dispatch(
        toastPush({
          code: 200,
          type: 'success',
          title: 'SUCCESS',
          body: 'toastPush.updatedSuccessful',
        })
      );
      queryClient.invalidateQueries(['globalCutOffInfo', variables.id]);
    },
  });
};
